<template>
  <div class="sidebar-content sidebar-content--jacket">
    <h1 class="sidebar-title">Body Color</h1>
    <h3 class="sidebar-subtitle">Pick a Body Color</h3>

    <ColorPicker
      :colors="colorsCategories.jacketBodyColors"
      @onSelectColor="onSelectColor"
    />
      <div class="color-label">Selected Color:</div>
      <b>{{ bodyColor.title }}</b>
  </div>
</template>

<script>
import ColorPicker from '@/components/common/ColorPicker.vue';

export default {
  name: 'BodySidebar',
  components: {
    ColorPicker
  },

  data () {
    return {
      colors: [],
    };
  },

  computed: {
    bodyColor () {
      return this.$store.getters['design/getBodyColor'];
    },
    colorsCategories () {
      return this.$store.getters['elements/getColorsCategories'];
    },
  },

  methods: {
    onSelectColor (color) {
      this.$store.commit('design/setBodyColor', { color });
    }
  }
};
</script>

<style scoped>
.color-label {
  margin-top: 10px;
}

.description {
  font-size: 18px;
  text-align: left;
  padding: 0 30px 0 30px;
  margin-top: 20px;
  font-style: italic;
}
</style>
